import {
  createActions, asyncInitialState, asyncOnRequest,
  asyncOnSuccess, asyncOnError, asyncSelectors,
} from '../utils'

export const { types, actions } = createActions({
  setSelected: (row) => ({ row }),
  clearLines: () => null,
  asyncs: {
    fetchComponentDetails: ({ Invoice, SalesEntity, LineNumber }) => ({ Invoice, SalesEntity, LineNumber })
  }
}, 'BOM');


const initialState = asyncInitialState({
  selected: null,
  gridOptions: {
    doubleClickActionTab: 'InvoiceLineBOMComponent',
    suppressEditDeleteInContextMenu: true,
  },
  lineColumns: [
    { headerName: 'Line', field: 'LineNumber', type: 'numericColumn', minWidth: 100, suppressSorting: true, },
    {
      headerName: 'Product',
      field: 'ProductCode',
      minWidth: 150,
      suppressSorting: true,
      hyperlinkParamGetter: (row) => {
        if (row.data && row.data.ProductCode) {
          return {
            ProductId: row.data.ProductId,
            FieldValue: row.data.ProductCode
          };
        } else {
          return null;
        }
      },
      cellRenderer: 'hyperLinkRenderer',
      cellRendererParams: {
        link: '/inventory-enquiry'
      }
    },
    { headerName: 'Product group', field: 'ProductGroup', minWidth: 150, suppressSorting: true, },
    { headerName: 'Required', field: 'RequiredQuantityDisplay', type: 'numericColumn', minWidth: 150, suppressSorting: true, },
    { headerName: 'Supplied', field: 'SuppliedQuantityDisplay', type: 'numericColumn', minWidth: 150, suppressSorting: true, },
    { headerName: 'Description', field: 'Description', minWidth: 250, suppressSorting: true, }
  ],
  lines: [],
  details: null
});

export default (state = initialState, action) => {
  switch (action.type) {
    case types.clearLines:
      return initialState
    case types.setSelected:
      const selected = action.data.row;
      return {
        ...state,
        data: {
          ...state.data,
          selected: selected
        }
      }
    case types.fetchComponentDetails:
      return asyncOnRequest(state, action)

    case types.saga.fetchComponentDetails.success:
      return asyncOnSuccess(state, action, (data, action) => {
        const details = action.payload;
        return {
          ...data,
          details: details
        }
      })
    case types.saga.fetchComponentDetails.failure:
      return asyncOnError(state, action);
    default:
      return state;
  }
};

const asyncSelector = asyncSelectors(
  (state) => state.salesInvoiceEnquiry.BOM,
  {
    lines: data => data.lines,
    selected: data => data.selected,
    details: data => data.details
  }
)

const syncSelector = {
  isLoading: state => state.salesInvoiceEnquiry.BOM.fetch_loading,
  loadingDetails: state => state.salesInvoiceEnquiry.BOM.fetchComponentDetails_loading,
  gridOptions: state => state.salesInvoiceEnquiry.BOM.data.gridOptions,
  lineColumns: state => state.salesInvoiceEnquiry.BOM.data.lineColumns,
}

export const selectors = Object.assign({}, asyncSelector, syncSelector)